import { fetchNewbuildingsSummary } from '../../services/newbuildingsSummary';
import { ELoadingStatus } from '../../types/redux/loadingStatus';
import type { TThunkAction } from '../../types/redux/thunk';
import {
  getNewbuildingsSummaryFailed,
  getNewbuildingsSummaryLoading,
  getNewbuildingsSummarySucceed,
} from './getNewbuildingsSummaryActions';

export function getNewbuildingsSummary(): TThunkAction<Promise<void>> {
  return async (dispatch, _getState, { httpApi, logger }) => {
    dispatch(getNewbuildingsSummaryLoading());

    try {
      const summary = await fetchNewbuildingsSummary({ httpApi });

      dispatch(getNewbuildingsSummarySucceed(summary));
    } catch (error) {
      logger.error('Error at fetchNewbuildingsSummary', {
        message: error.message,
      });
      dispatch(getNewbuildingsSummaryFailed());
    }
  };
}

export function getNewbuildingsSummarySafe(): TThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    const { status } = getState().newbuildingsSummary;

    if (status === ELoadingStatus.Loading || status === ELoadingStatus.Succeed) {
      return;
    }

    await dispatch(getNewbuildingsSummary());
  };
}
